export default {
  EU: 'EU',
  ASEAN: 'ASEAN',
};
